import { h } from 'preact';

import Loadable from 'react-loadable';

export default Loadable({
    loader: () => import('../../../../q-cars/src/containers/Partnership/partnershiparea.js'),
    loading: () => <div></div>,
    render(loaded,props) {
        let Leads = loaded.default;
        return <Leads {...props} />;
    }
});


// WEBPACK FOOTER //
// ../q-cars/src/containers/Partnership/index.js